// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__9qDEF","text":"style_text__40qsK","loading":"style_loading__mWJm3","l13":"style_l13__HhcDg"};